// domain-extractor.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'extractDomain'
})
export class ExtractDomainPipe implements PipeTransform {
  transform(url: string): string {
    // Regex pattern to match domain
    const domainPattern = /^(?:https?:\/\/)?(?:www\.)?([^\/]+)/;
    const match = url.match(domainPattern);
    if (match && match.length > 1) {
      return match[1];
    } else {
      return 'Invalid URL';
    }
  }
}
